import "./UwFireImport.scss";
import { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import { useTranslation } from 'react-i18next';
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import ErrorDialog from "../../../components/errorDialog/ErrorDialog.jsx";
import ProgressDialog from "../../../components/progressDialog/ProgressDialog.jsx";
import { motion } from "framer-motion";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import { formatStringToNumberV2, generateUniqueCode } from "../../../utils/genericFunctions.js";
import { MdAttachment, MdClose, MdOutlineCheck, MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import numeral from "numeral";
import readXlsxFile from "read-excel-file";
import { PiWarningFill } from "react-icons/pi";
import { IoIosRemoveCircle } from "react-icons/io";
import { useRef } from "react";


const UwFireImport = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef(null);
  const subClassToPass = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showUpload, setShowUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [openProgressDialog, setOpenProgressDialog] = useState(false);
  const [riskPage, setRiskPage] = useState(0);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [expanded, setExpanded] = useState(false);

  const handleRiskChangePage = (event, newPage) => {
    setRiskPage(newPage);
  };

  const handleRiskChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setRiskPage(0);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setShowUpload(false);
    if (!file) return;
    let riskRegnArray = [];
    let errorsCount = 0;

    setUploading(true);

    try {
      const rows = await readXlsxFile(file, { sheet: 2 });
      const data = rows.slice(1).map((row, index) => {
        const particularDetails = row[0];
        const address = row[1] || "";
        const cover = row[2] || "";
        const smi1Title = row[3] || "";
        let smi1SumInsured = row[4] || 0;
        let smi1Rate = row[5] || 0;
        const smi2Title = row[6] || "";
        let smi2SumInsured = row[7] || 0;
        let smi2Rate = row[8] || 0;

        let result_xx = "Ready for upload";


        if (!particularDetails) {
          result_xx = "MISSING PARTICULARS";
          errorsCount++;
        }


        if (!["040", "041", "EQ", "PVT"].includes(cover)) {
          result_xx = "Cover MUST be 040, 041, EQ or PVT"; errorsCount++;
        }

        smi1SumInsured = parseFloat(formatStringToNumberV2(smi1SumInsured || 0, 2)) || 0;
        smi1Rate = parseFloat(formatStringToNumberV2(smi1Rate || 0, 4)) || 0;

        smi2SumInsured = parseFloat(formatStringToNumberV2(smi2SumInsured || 0, 2)) || 0;
        smi2Rate = parseFloat(formatStringToNumberV2(smi2Rate || 0, 4)) || 0;

        let totalSumInsured = 0;
        if (smi1SumInsured && !smi2SumInsured) {
          totalSumInsured = smi1SumInsured;
        } else if (!smi1SumInsured && smi2SumInsured) {
          totalSumInsured = smi2SumInsured;
        } else if (smi1SumInsured && smi2SumInsured) {
          totalSumInsured = smi1SumInsured + smi2SumInsured;
        }

        const rowid = generateUniqueCode();
        return {
          _id: rowid,
          particularDetails,
          address,
          cover,
          smi1Title,
          smi1SumInsured,
          smi1Rate,
          smi2Title,
          smi2SumInsured,
          smi2Rate,
          smi1SumInsured,
          totalSumInsured,
          result_xx,
          index
        };
      });


      console.log(`setExcelData...  ${JSON.stringify(data, null, 2)}}`);

      setExcelData(data);
      setUploading(false);

      if (errorsCount === 0) {
        setShowUpload(true)
      }

    } catch (error) {
      console.error("Error reading Excel file:", error);
      setUploading(false);
    }
  };

  const resetFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // clears the selected file
      console.log("File input reset");
    }
  };

  const updateRecordStatus = (index, result_xx) => {
    try {
      const updatedData = [...excelData];
      const currentRow = updatedData[index];
      currentRow["result_xx"] = result_xx;
      setExcelData(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const filteredRiskData = excelData.filter(
    (item) =>
      item?.particularDetails?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.address?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.smi1Title?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.smi2Title?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const slicedRiskData = filteredRiskData.slice(
    riskPage * rowsPerPage,
    riskPage * rowsPerPage + rowsPerPage
  );



  const handleAccodionChange = (id, vrow) => (event, isExpanded) => {
    setExpanded(isExpanded ? id : null);
  };


  const handleSubmit = async () => {
    try {

      setOpenProgressDialog(true);
      const responseArray = [];
      const totalRecords = excelData.length;
      let completedRecords = 0;

      for (const record of excelData) {
        const progress = Math.round((completedRecords / totalRecords) * 100);
        setProgress(progress);
        // console.log(`subClassToPass ${JSON.stringify(subClassToPass, null, 2)}`);
        try {
          const uploadedRisk = {
            ...record,
            ...subClassToPass,
            ps_order: completedRecords,
            subclass_docid: subClassToPass._id,
            pr_code: subClassToPass.pr_code,
          }
          const res = await newRequest.post("/uwPolicyRisk/uploadFire", uploadedRisk);
          // console.log(`/uwPolicyRisk/uploadFire ${JSON.stringify(res.data, null, 2)}`);
          responseArray.push({
            record_index: completedRecords,
            response: res.data
          });
        } catch (error) {
          console.log(error);
        }
        completedRecords++;
      }


      let uploadedCount = 0;
      let restCount = 0;

      // console.log(`responseArray ${JSON.stringify(responseArray, null, 2)}`);

      // loop to update response data
      for (const record of responseArray) {
        if (record.response === "Uploaded") {
          uploadedCount++;
        } else {
          restCount++;
        }

        updateRecordStatus(
          record.record_index,
          record.response
        );
      }

      // calculate premium
      const res = await newRequest.post("/uwPolicy/refresh", { policy_docid: subClassToPass.ps_policy_docid });

      setProgress(100);
      setOpenProgressDialog(false);

      setNotifyDialogTitle("Please Note...");
      setNotifyDialogText(`<div>Total Records Processed <strong>${responseArray.length}</strong></div>
      <div>Successfully Uploaded <strong>${uploadedCount}</strong></div>
      <div>Errors <strong>${restCount}</strong></div>
      <div><br/></div>
      <div><p>Rectify the Records with errors and try again </p> </div>`);
      setIsNotifyDialogOpen(true);
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };

  return (
    <motion.div
      className="fire-import"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="navbar">
        <div className="navbar-left">
          <div className="search-input-wrapper" style={{ width: "60%" }}>
            <FiSearch className="search-input-icon" />
            <input
              className="search-input"
              type="text"
              placeholder={t('search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm?.length > 0 && (
              <MdClose
                onClick={() => setSearchTerm("")}
                className="search-input-icon"
              />
            )}
          </div>
        </div>
        <div className="navbar-right">
          <div className="file-upload-item"
            onClick={async () => {
              try {
                const response = await newRequest.get("/uploadTemplates/fire-template", {
                  responseType: "blob",
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "fire-template.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.log(error);
              }
            }}>
            <MdOutlineFileDownload />
            <span>{t('downloadTemplate')}</span>
          </div>
          <input
            type="file"
            accept=".xlsx, .xls"
            ref={fileInputRef}
            id="file"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <label htmlFor="file">
            <div className="file-upload-item">
              <MdAttachment /> <span>{t('selectFile')}</span>
            </div>
          </label>
          <div className="file-upload-item"
            onClick={async () => {
              try {
                setExcelData([]);
                setShowUpload(false);
                setSearchTerm("");
                resetFile();
              } catch (error) {
                console.log(error);
              }
            }}>
            <IoIosRemoveCircle />
            <span>{t('reset')}</span>
          </div>
          {showUpload && (
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="start"
              borderRadiusType="left"
              endIcon={<MdOutlineFileUpload />}
              onClick={handleSubmit}
              disabled={!excelData.length || uploading}
            >
              {uploading ? "Uploading..." : "Upload"}
            </CustomLoadingButton>
          )}
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="right"
            endIcon={<MdClose />}
            onClick={() => navigate(-1)}
          >
            {t('close').toUpperCase()}
          </CustomLoadingButton>
        </div>
      </div>
      {slicedRiskData?.length > 0 &&
        <div className="table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedRiskData?.map((vrow, index) => (
                  <TableRow
                    key={vrow?._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}>
                      <Accordion className="accordion" expanded={expanded === vrow?._id} onChange={handleAccodionChange(vrow?._id, vrow)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${vrow?._id}-header`}
                        >
                          <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between", width: "100%", marginRight: "50px" }}>
                            <span style={{ display: "flex", width: "50px", fontWeight: "bold" }}>{riskPage * rowsPerPage + index + 1}</span>
                            <span style={{ display: "flex", flex: "2" }}>{vrow?.particularDetails}</span>
                            <span style={{ display: "flex", flex: "1" }}>{vrow?.cover}</span>
                            <span style={{ display: "flex", flex: "1", justifyContent: "flex-end" }}>{numeral(vrow?.totalSumInsured).format("0,0.00")}</span>
                            <span style={{ display: "flex", flex: "1.5" }}>{vrow?.result_xx}</span>
                            {["Ready for upload", "Uploaded"].includes(vrow?.result_xx) && <MdOutlineCheck size={20} color="green" />}
                            {!["Ready for upload", "Uploaded"].includes(vrow?.result_xx) && <PiWarningFill size={20} color="red" />}
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div style={{ display: "flex", gap: "10px", padding: "5px 20px 5px 20px", alignItems: "center", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title">{vrow?.smi1Title}</span>
                              <span className="sub-title">{numeral(vrow?.smi1SumInsured).format("0,0.00")}</span>
                              <span className="sub-title">{numeral(vrow?.smi1Rate).format("0,0.0000")}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title">{vrow?.smi2Title}</span>
                              <span className="sub-title">{numeral(vrow?.smi2SumInsured).format("0,0.00")}</span>
                              <span className="sub-title">{numeral(vrow?.smi2Rate).format("0,0.0000")}</span>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleRiskChangeRowsPerPage}
              component="div"
              count={filteredRiskData.length}
              page={riskPage}
              onPageChange={handleRiskChangePage}
            />
          </TableContainer>
        </div>}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader
              color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* Error dialog */}
      <ErrorDialog
        open={!!error}
        handleClose={() => setError("")}
        errorMessage={error}
      />
      {/* progress dialog for upload  */}
      <ProgressDialog
        open={openProgressDialog}
        handleClose={() => setOpenProgressDialog(false)}
        progress={progress}
        title="Uploading Risks. Please Wait...."
      />
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default UwFireImport;
